import { useOptionalPreference } from "@/contexts/PreferencesContext";
import { useTenantFeatureFlag, useTenantHomeScreenDefault } from "@/hooks/useTenantFeatureFlag";
import { useManagerAccess } from "@/hooks/useManagerAccess";
import { resolveHome, type HomeTarget } from "@/lib/home";

/**
 * いまの HOME（PRODUCT_DEV-1070・1092）。判定は `resolveHome`
 * （個人設定 → マネージャーなら活動サマリ → 会社の初期表示ページ → マイ手帳）。
 * `PreferencesProvider` の内側で使う（ロゴの行き先・グロナビの家の印・HOME の切り替え）。
 */
export const useHome = (): HomeTarget => {
  const diaryHomeEnabled = useTenantFeatureFlag("diaryHome");
  const [homeScreen] = useOptionalPreference("homeScreen");
  const tenantDefault = useTenantHomeScreenDefault();
  // PRODUCT_DEV-1092: マネージャーは活動サマリも HOME にでき、未設定なら活動サマリ
  const { canViewSummary } = useManagerAccess();
  return resolveHome(diaryHomeEnabled, homeScreen, tenantDefault, canViewSummary);
};
